import { DependencyList, useEffect, useRef } from 'react';

function useDebounce(cb: VoidFunction, deps: DependencyList, delay = 500): void {
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    const id = setTimeout(cb, delay);
    return () => clearTimeout(id);
  }, deps);
}

export default useDebounce;
